<template>
<div class="info col s12 m2 yo-valign-bottom" style="height:100%;">
   <div class="yo-text-s yo-text-bold yo-align-center yo-valign-text-center" :style="'height:'+(rowheight+8)+'px'">
      <div class="yo-text-xxxxl" style="margin-bottom:6px;">{{evento.crediti}}</div><span class=" ">crediti ECM</span>
   </div>
      <a v-if="info && evento.tipologiaformazione==1 && evento.linkcomplete!=''" :href="evento.linkcomplete" target="_blank" class="white yo-bg-color-primary yo-align-center" style="padding:10px 0;margin-top:10px;display:block;">Info & Iscrizione</a>
      <router-link v-if="info && evento.tipologiaformazione!=1" :to="'/evento-home/'+evento.id" class="white yo-bg-color-primary yo-align-center" style="padding:10px 0;margin-top:10px;display:block;">Info & Iscrizione</router-link>
</div>
</template>

<script>
export default {
   props: {evento: Object,rowheight: Number,info:Boolean}
}
</script>


// WEBPACK FOOTER //
// src/components/Evento-elenco-crediti.vue